import { getFirestore, getDocs, collection } from "firebase/firestore";
import app from '../../firebase';
import { useState, useEffect } from "react"

export default function ProfileServices() {

    const [reviews, setReviews] = useState();

    const getReviews = async () => {
        let x = [];
        
        await getDocs(collection(getFirestore(app), 'testimonials'))
            .then(results => results.forEach(i => x.push([i.id, i.data()])));

        setReviews(x);
    }

    useEffect(() => {
        getReviews();
        console.log('WORKING')
    }, []);

    return(
        <>
            <div className="container-fluid text-center bg-light">
            </div>
            <div className="container-fluid bg-success text-light text-center p-4">
                
                <div id="carouselExampleControls" className="carousel slide p-4" data-bs-ride="carousel" data-bs-interval="6000">
                    <div className="carousel-inner">
                        <div className="carousel-item active">
                                <p className="fs-4">WHAT OUR CUSTOMERS SAY TO OUR WORKS.</p>
                                <span className="d-block fw-bold">HOMEMOTO</span>
                        </div>

                        {
                            reviews && reviews.map(i => (
                                <div className="carousel-item">
                                    <p className="fs-4">{ i[1].message }</p>
                                    <span className="d-block fw-bold">{ i[1].by.toUpperCase() }</span>
                                </div>
                            ))
                        }

                    <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
                        <span className="carousel-control-prev-icon border rounded-circle" aria-hidden="true"></span>
                        <span className="visually-hidden">Previous</span>
                    </button>
                    
                    <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
                        <span className="carousel-control-next-icon border rounded-circle" aria-hidden="true"></span>
                        <span className="visually-hidden">Next</span>
                    </button>

                    </div>
                </div>
            </div>
        </>
    )
}